import { axiosInstance } from "./apiConfig"

export const apiGetBookingInfo = async ({ storeId, bookingCode }) => {
    try {
        const { data } = await axiosInstance.get(
            `/thirdparty/resdiary/store/${storeId}/booking/${bookingCode}`
        );
        data.VisitDate = data.VisitDate.split('T')[0];
        data.VisitTime = data.VisitTime.slice(0, 5);
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}


// WEBPACK FOOTER //
// ./src/api/apiGetBookingInfo.js